export const environment = {
  production: false,
  auth: {
    domain: "dev-wa1v1z5d.eu.auth0.com",
    clientId: "E6Lzb3ShgY2Gu90C8Sw173sfQLpy1yM9",
    redirectUri: window.location.origin,
    errorPath: "/error",
    audience: "localhost",
  },
  httpInterceptor: {
    allowedList: [
      "https://safer-cities-apim-dev.azure-api.net/safer-cities-function-dev/v1/back-office/*",
      "https://safer-cities-apim-dev.azure-api.net/safer-cities-function-dev/v1/response-export",
    ],
  },
  apiUri:
    "https://safer-cities-apim-dev.azure-api.net/safer-cities-function-dev/v1",
  apimSubscriptionKey: "ab9b032f4808498c94884db99f01c4f2",
};
